import { Component, OnInit } from '@angular/core';
import { RestService } from '../../service/rest.service';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styles: [],
  standalone: false
})
export class ServicesComponent implements OnInit {

  constructor(private rest: RestService, private message: Message, private loader: LoaderService) { }

  currentHover = -1
  myFormData = new FormData()

  openInput() {
    let input = document.getElementById('upload-cv')
    input?.click()
  }

  ngOnInit(): void { }

  changeInput(event: any) {
    if (event.target.files[0]) {
      this.loader.on()
      this.myFormData.append('file', event.target.files[0])
      this.rest.post('/user/curriculum', this.myFormData).subscribe({
        next: (value) => {
          this.loader.off(false)
          this.message.showMessage('Curriculum caricato con successo', 'success')
        },
        error: (value) => {
          this.loader.off(false)
          this.message.showMessage('Errore nel caricamento del file', 'error')
        },
      })
    }
  }

  goToContacts() {
    window.location.replace('contatti')
  }
}
